<template>
  <div class="h-full p-20px">
    <div class="flex flex-column h-full">
      <vxe-toolbar class-name="px-16px" :loading="loading">
        <template #buttons>
          <account-date-choose v-model="entryDate"/>
        </template>
        <template #tools>
          <i class="vxe-icon-setting" style="cursor: pointer; color: #3385ff" @click="salaryVoucherSettings"><a style="margin-left: 5px">工资凭证设置</a></i>
        </template>
      </vxe-toolbar>
      <div class="checkout-content">
        <div id="itemBoxsContext" class="item-boxs-context">
          <div class="item-box item-box-create" id="salesCost0" v-for="item in dataList">
            <div class="item-box-title">{{item.title}}</div>
            <div class="money">
              <span class="currecy has-currency hasCurrency tooltip-f" title="">{{ item.totalAmount }}</span>
            </div>
<!--            <div class="check-btn create-voucher-btn" @click="generateVouchers('AccruedSalary')">生成凭证</div>-->
             <router-link v-if="item.hasVoucher" @success="loadList()" width="1120px" tag="button" :to="{name:'VoucherForm',params:{voucherId:item.voucherIdList[0]}}" class="check-btn view-voucher-btn">查看凭证</router-link>
             <router-link v-if="!item.hasVoucher" @success="loadList()"  width="1120px" tag="button" :to="{name:'VoucherForm', params: {salaryVoucherData:item,salaryDate:entryDate}}" class="check-btn create-voucher-btn">生成凭证</router-link>
          </div>
<!--          <div class="item-box item-box-create" id="salesCost1">
            <div class="item-box-title">发放工资</div>
            <div class="money">
              <span class="currecy has-currency hasCurrency tooltip-f" title="">{{ PayrollSalary }}</span>
            </div>
            <router-link width="1024px" tag="button" :to="{name:'VoucherForm', params: ''}" class="check-btn create-voucher-btn">生成凭证</router-link>
          </div>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>


  import {mapGetters, mapState} from "vuex";

 /**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2019-2020金华企客观网络科技有限公司All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : </li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2020年08月08日</li>
 * <li>@author     : ____′↘企万慧</li>
 * </ul>
 * <p>****************************************************************************</p>
 */

  export default {
    name: "SalaryManagement",
    computed: {
      ...mapState(['currentAccountSets']),
      ...mapGetters(['checkoutSelect', 'localCurrency']),
      deptListMap() {
        let map = {};
        this.deptList.map(val => {
          map[val.key] = val.title;
        })
        return map;
      },
    },
  }
</script>
<script setup>
  import {ref, h, watch, reactive} from "vue";
  import manba from "manba";
  import {useStore} from 'vuex'
  import SalaryChange from "@/api/SalaryChange";
  import SalaryVoucherTemplate from "@/views/salary/SalaryVoucherTemplate";
  import {layer} from "@layui/layer-vue";
  import SalaryManage from "../../api/SalaryManage";
  import {message} from "heyui.ext";

  const store = useStore();
  const {currentAccountSets} = store.state

  const paramsDropdown = ref(null);
  const loading = ref(false);

  const entryDate = ref(currentAccountSets.currentAccountDate)

  const updating = ref(false);

  const AccruedSalary = ref(0.00);
  const PayrollSalary = ref(0.00);

  const params = reactive({
    entryDate: entryDate,
    deptId: null,
    name: null
  });
  const dataList = ref([]);

  const loadList = () => {
    // SalaryChange.length(entryDate.value).then(() => {
    // })
    // AccruedSalary.value = '5211.12'
    // PayrollSalary.value = '3689.88'
    SalaryManage.salaryTemplateAmountList({entryDate:params.entryDate}).then(res=>{
      console.log(res)
      //模版没有设置提醒jxd
      res.data.forEach(item => {
        if(item.items.length == 0){
          message(`${item.title}模版未设置，请先设置！`);
        }
      });
      dataList.value = res.data;
    });
  }
  loadList();

  // 工资凭证设置接口
  const salaryVoucherSettings = () => {
    layer.drawer({
      title: "工资凭证设置",
      zIndex: 1000,
      area: ['700px', '100vh'],
      content: h(SalaryVoucherTemplate,{
        onSuccess: ()=>{
          loadList();
        },
      }),
      onClose: (args) => {
        loadList();
      }
    });
  }

  // 个税申报接口
  const generateVouchers = (type) => {
    if (type === 'AccruedSalary') {

    } else if (type === 'PayrollSalary') {

    }

  }

  watch(entryDate, () => {
    loadList();
  })

</script>

<style lang="less" scoped>
  .checkout-content {
    position: relative;
    background-color: #ffffff;
    min-height: 496px;
  }
  .item-boxs-context {
    margin-left: -26px;
    min-height: 348px;
  }
  .item-boxs-context .item-box {
    width: 218px;
    height: 153px;
    border: 1px solid #dadada;
    display: inline-block;
    margin-left: 26px;
    margin-bottom: 20px;
  }
  .item-box .item-box-title {
    color: #333333;
    font-size: 16px;
    line-height: 36px;
    border-bottom: 1px solid #dadada;
    text-align: center;
  }
  .money {
    height: 25px;
    margin-top: 20px;
    margin-bottom: 20px;
    text-align: center;
  }
  .money .currecy.has-currency {
    color: #44b449;
    text-decoration: underline;
    cursor: pointer;
  }
  .money .currecy {
    font-size: 19px;
    line-height: 25px;
    display: inline-block;
  }
  .check-btn.create-voucher-btn {
    background-color: #44b449;
  }
  .check-btn.view-voucher-btn {
    background-color: #3b76f5;
  }
  .check-btn {
    height: 30px;
    width: 96px;
    text-align: center;
    color: #ffffff;
    font-size: 14px;
    line-height: 30px;
    border-radius: 2px;
    margin: 0 auto 20px;
    cursor: pointer;
  }
</style>
